export enum UserRole {
  SUPER_ADMIN = 'superAdmin',
  SALES_AGENT = 'salesAgent',
  SALES_MANAGER = 'salesManager',
  SALES_QUALITY_MANAGER = 'salesQualityManager',
  SALES_QUALITY_AGENT = 'salesQualityAgent',
  MARKETING_EXECUTIVE = 'marketingExecutive',
  FINANCE_OFFICER = 'financeOfficer',
  E_COMMERCE_AUTO = 'eCommerceAuto',
  E_COMMERCE_FINANCE = 'eCommerceFinance',
  E_COMMERCE_SERVICE_CENTER = 'eCommerceServiceCenter',
  E_COMMERCE_REFERRAL = 'eCommerceReferral',
  E_COMMERCE_MANAGER = 'eCommerceManager',
  INSURANCE_MANAGER = 'insuranceManager',
  INSURANCE_AGENT = 'insuranceAgent',
  OPERATION_MANAGER = 'operationManager',
  OPERATION_AGENT = 'operationAgent',
  ADMIN = 'admin',
  GUEST = 'guest',
  HELP_DESK_SUPPORT = 'helpDeskSupport',
  HR_REPRESENTATIVE = 'hrRepresentative',
  HR_MANAGER = 'hrManager',

  //Partner Roles
  FINANCE_MERCHANT_AGENT = 'financeMerchantAgent',
  FINANCE_MERCHANT_MANAGER = 'financeMerchantManager',
  FINANCE_MERCHANT_ADMIN = 'financeMerchantAdmin',
  SERVICE_CENTER_MERCHANT_AGENT = 'serviceCenterMerchantAgent',
  SERVICE_CENTER_MERCHANT_MANAGER = 'serviceCenterMerchantManager',
  SERVICE_CENTER_MERCHANT_ADMIN = 'serviceCenterMerchantAdmin',
  AUTO_MERCHANT_AGENT = 'autoMerchantAgent',
  AUTO_MERCHANT_MANAGER = 'autoMerchantManager',
  AUTO_MERCHANT_ADMIN = 'autoMerchantAdmin',
  REFERRAL_PARTNER = 'referralPartner',
  REFERRAL_CUSTOMER = 'referralCustomer',
  REFERRAL_FREELANCER = 'referralFreelancer'
}

export enum FinanceMerchantRoles {
  FINANCE_MERCHANT_AGENT = 'financeMerchantAgent',
  FINANCE_MERCHANT_MANAGER = 'financeMerchantManager',
  FINANCE_MERCHANT_ADMIN = 'financeMerchantAdmin'
}

export enum SalesRoles {
  SALES_AGENT = 'salesAgent',
  SALES_MANAGER = 'salesManager'
}
